module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.50cf9a72.woff";